module.exports = __webpack_public_path__ + "img/mobilehardware6.bb87f9a7.png";